module.exports = __webpack_public_path__ + "assets/img/W1-4-F.5ebce639.png";